import React from 'react';
import { Link } from 'react-router-dom';

const ComingSoon = () => {
    return (
        <div className="min-h-[calc(100vh-200px)] bg-gradient-to-br from-blue-50 via-white to-blue-100 flex items-center justify-center p-2">
            <div className="max-w-2xl w-full text-center space-y-8 bg-white p-8 md:p-8 rounded-3xl shadow-xl transform transition-all hover:scale-[1.01]">
                <div className="animate-pulse flex justify-center mb-6">
                    <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center">
                        <i className="fas fa-tools text-3xl text-blue-600"></i>
                    </div>
                </div>

                <div className="space-y-4">
                    <h1 className="text-4xl md:text-4xl font-bold text-gray-900 tracking-tight">
                        <span className="text-blue-600">Coming</span> Soon
                    </h1>
                    <p className="text-lg text-gray-600 max-w-lg mx-auto leading-relaxed text-center">
                        We're currently working hard on this page to bring you the best experience. It will be available very soon!
                    </p>
                </div>

                <div className="pt-8 flex flex-col sm:flex-row justify-center gap-4 sm:gap-6">
                    <Link
                        to="/"
                        className="px-8 py-3.5 bg-blue-600 text-white rounded-xl no-underline font-semibold shadow-lg hover:bg-blue-700 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 flex items-center justify-center gap-2"
                    >
                        <i className="fas fa-home"></i> Back to Home
                    </Link>
                    <Link
                        to="/contact-us"
                        className="px-8 py-3.5 border-1 no-underline bg-white text-blue-600 border-2 border-blue-700 rounded-xl font-semibold shadow-sm hover:bg-blue-50 hover:border-blue-200 transition-all duration-300 flex items-center justify-center gap-2"
                    >
                        <i className="fas fa-envelope"></i> Contact Us
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default ComingSoon;
